import http from "./httpService";
import config from "../config.json";

const apiEndpoint = config.apiEndpoint + "/matches";

export async function getMatches() {
  const response = await http.get(apiEndpoint);
  return response.data;
}

export async function getMatch(id) {
  const response = await http.get(apiEndpoint + "/" + id);
  return response.data;
}

export async function getUnfinishedMatch(userId, leagueId) {
  const response = await http.get(apiEndpoint + "/" + userId + "/" + leagueId);
  return response.data;
}

export async function saveMatch(match) {
  let matchInDb = match || {};

  if (matchInDb.id === -1) await http.post(apiEndpoint, matchInDb);
  else await http.put(apiEndpoint + "/" + matchInDb.id, matchInDb);

  return matchInDb;
}

export async function deleteMatch(id) {
  await http.delete(apiEndpoint + "/" + id);
}



// WEBPACK FOOTER //
// ./src/services/matchService.js